/** Source-approved category commands, without invented tender behavior. */
export const omniCategoryNames=[
  ['services','Services'],['packages','Packages'],
  ['memberships','Memberships'],['products','Products'],
  ['giftCards','Gift Cards'],['discounts','Discount Codes'],
] as const;
export type OmniCategory=typeof omniCategoryNames[number][0];
const aliases:Readonly<Record<string,OmniCategory>>={
  services:'services','service credits':'services',packages:'packages',
  memberships:'memberships',products:'products',
  'gift cards':'giftCards','discount codes':'discounts',
};
export function parseOmnibarCategoryCommand(value:string):OmniCategory|null{
  const name=value.toLowerCase().trim().replace(/\s+/g,' ');
  return Object.prototype.hasOwnProperty.call(aliases,name)?aliases[name]:null;
}
